import firebase from 'firebase'


  // Initialize Firebase
  const config = {
    apiKey: "AIzaSyAqcceg6A_bSPUJhNBtlIa0fQ6SOSjONUc",
    authDomain: "eventos-yt-74d35.firebaseapp.com",
    databaseURL: "https://eventos-yt-74d35.firebaseio.com",
    projectId: "eventos-yt-74d35",
    storageBucket: "eventos-yt-74d35.appspot.com",
    messagingSenderId: "486394821768"
  };
 const fire =  firebase.initializeApp(config);
 export default fire
